import { z } from "zod";
import { linkTokenHashSchema } from "./linkTokenHashSchema";

export const CancelMagicLinkInputSchema = z.object({
    linkTokenHash: linkTokenHashSchema,
});

export type CancelMagicLinkInput = z.infer<typeof CancelMagicLinkInputSchema>;
